import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from "@/plugins/utils";
import VueLazyload from "vue-lazyload";
import uploader from "vue-simple-uploader";
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import axios from "axios";
import "@/assets/icon/iconfont.css";
// 导入ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/scss/init.scss";
import "@/assets/scss/commons.scss";
import "@/assets/scss/element.scss";
Vue.use(ElementUI);
const Base64 = require("js-base64").Base64;
// 加载过滤器
import * as filters from "@/plugins/filter";
import JSEncrypt  from 'jsencrypt';
Vue.prototype.$jsEncrypt = JSEncrypt
Vue.prototype.axios = axios;
Vue.prototype.ajaxUrl = "http://192.168.11.56:8992";

import qs from "qs";
Vue.prototype.qs = qs;
import Bus from "@/libs/upload/bus";

Vue.use(VideoPlayer);
Vue.use(uploader);
// 自定义指令插件
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive("real-img", async function(el, binding) {
  //指令名称为：real-img
  let imgURL = binding.value; //获取图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
    }
  }
});
/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
  return new Promise((resolve) => {
    var img = new Image();
    img.onload = function() {
      if (this.complete == true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = function() {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
};

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.component("globalUploader", () => import("@/components/global-Uploader"));
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  Base64,
  render: (h) => h(App),
  created() {
    // 路由较验
    if (process.env.NODE_ENV === "development") {
      let tokens = utils.cookies.get("token");
      if (tokens) utils.cookies.set("token", tokens);
    }
  },

  mounted() {
    // if (utils.cookies.get("token") == null || utils.cookies.get("token") == undefined) {
    //   console.log(router);
    //   this.$router.push({
    //     name: "login",
    //     query: this.$route.query,
    //   });
    // }
  },
  methods: {
    // 跳转至登录路由
    jumpLogin() {
      this.$router.push({
        name: "login",
        query: this.$route.query,
      });
    },
  },
}).$mount("#app");
function newFunction() {
  return "token";
}
